export default "__VITE_ASSET__f117f6fb__"